import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input } from 'antd';
import { useCancelServiceMutation } from '../../../../graphql/datamodel.gen';
import { getClient } from '../../../../apollo';
import { FormComponentProps } from '@ant-design/compatible/es/form';

interface IProps {
  serviceId: string;
}

const CancelServiceForm: React.FC<IProps> = (props: IProps) => {
  const [cancelService] = useCancelServiceMutation({
    client: getClient(),
  });

  const _cancelService = async (reason?: string) => {
    return cancelService({
      variables: {
        id: props.serviceId,
        reason,
      },
    });
  };

  return <MyCancelServiceForm cancelService={_cancelService} />;
};

interface IViewProps extends FormComponentProps {
  cancelService: (reason?: string) => Promise<any>;
}

interface IViewState {}

class CancelServiceFormView extends React.Component<IViewProps, IViewState> {
  handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    try {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { reason }: { reason?: string } = values;
          this.props.cancelService(reason);
        }
      });
    } catch (err) {}
  };

  render(): React.ReactNode {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} id="cancel-service-form">
        <Form.Item label={'Motivo'}>
          {getFieldDecorator('reason', {
            rules: [
              {
                required: false,
              },
              {
                whitespace: true,
                message: 'Evita escribir únicamente carácteres en blanco',
              },
            ],
          })(
            <Input.TextArea
              placeholder="Opcionalmente puedes indicar el motivo de la anulación"
              autoSize={{ minRows: 3, maxRows: 5 }}
            />,
          )}
        </Form.Item>
      </Form>
    );
  }
}

const MyCancelServiceForm = Form.create<IViewProps>()(CancelServiceFormView);

export default CancelServiceForm;
